
import { EditUserRelativesDto } from './editUserRelatives';
import { PortalUserAttachmentsDto } from './PortalUserAttachmentsDto';
import { ScPortalRequestDuties } from './ScPortalRequestDuties';
import { ScPortalRequestIncome } from './ScPortalRequestIncome';

export class EditUserPortal{
    name:string;
    nameEn:string;
    employer:string;
    notes:string;
    birthDate:string;
    birthDateStr:string;
    idExpirationDate:string;
    idExpirationDateStr:string;
    genderLkpId:number;
    cityLkpId:number;
    caseCategoryLkpId:number;
    qualificationLkpId:number;
    educationalStageLkpId:number;
    maritalStatusLkpId:number;
    branchLkpId:number;
    region:string;
    idNumber:string;
    wifeHusbandName1:string;
    idNumberWifeHusband1:string;
    jobWifeHusband1:string;
    wifeNationalityLkpId:number;
    wifeIdExpirationDate:string;
    wifeHelthStatusLkpId:number;
    wifeQualificationLkpId:number;
    wifeName2:string;
    idNumberWife2:string;
    jobWife2:string;
    wifeNationality2LkpId:number;
    wifeIdExpirationDate2:string;
    wifeHelthStatus2LkpId:number;
    wifeQualification2LkpId:number;
    wifeName3:string;
    idNumberWife3:string;
    jobWife3:string;
    wifeNationality3LkpId:number;
    wifeIdExpirationDate3:string;
    wifeHelthStatus3LkpId:number;
    wifeQualification3LkpId:number;
    wifeName4:string;
    idNumberWife4:string;
    jobWife4:string;
    wifeNationality4LkpId:number;
    wifeIdExpirationDate4:string;
    wifeHelthStatus4LkpId:number;
    wifeQualification4LkpId:number;
    nationalityLkpId:number;
    mobileNumber1:string;
    mobileNumber2:string;
    jobDescription:string;
    job:string;
    sponsorName:string;
    countryNo:string;
    address:string;
    passportNumber:string;
    unifiedNumber:string;
    passportIssueDate:string;
    passportExpiryDate:string;
    residenceEndDate:string;
    userDuties:ScPortalRequestDuties[];
    userIncomes:ScPortalRequestIncome[];
    userRelatives:EditUserRelativesDto[];
    userAttachments:PortalUserAttachmentsDto[];

    //userFinancial:EditUserFinancialDto[];
    bankLkpId:number;
    bankLkp:string;
    accountNumber:string;
    accountOwner:string;
    ibanNumber:string;
    id:number;

    electricityMeterNumber:string;
    houseNumber:string;
}
